import { MandatoryAmountValidator } from '@src/common/fields/AmountValidator';

export class AmountField {
  public static fieldName = 'amount' as const;
  public static validator = (preauthorizedAmount: number) =>
    MandatoryAmountValidator.max(preauthorizedAmount, 'maxSettlementAmount');
}
